export enum TrackedTimeActionsEnum {
  bill_time = 'bill_time',
}
